module.exports = __webpack_public_path__ + "img/m_lszkqr.3c44a616.png";